import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SEO from "../components/SEO";
// const shuffleArray = (array) => {
//   const shuffled = [...array];
//   for (let i = shuffled.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
//   }
//   return shuffled;
// };
const Photos = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [images, setImages] = useState([]);
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
const originalImages = [
  {
    src: "/images/gallery/harisharan-devgan-jpsc-exam-issue-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-case-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-exam-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-scam-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-recruitment-issue-press-conference.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-jpsc-exam-row-supreme-court.webp",
  },
  {
    src: "/images/gallery/jpsc-exam-row-reaches-supreme-court-harisharan-devgan.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-13.webp",
  },
  {
    src: "/images/gallery/harisharaan-devgan-at-school-1.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-12.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-14.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-16.webp",
  },
  {
    src: "/images/gallery/harisharaan-devgan-at-school.webp",
  },
  {
    src: "/images/gallery/mou-exchange-between-iitk-niche-agriculture-1.jpg",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-03.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_1.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-04.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-09.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_2.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-11.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_3.webp",
  },
  {
    src: "/images/gallery/harisharaan-devgan-at-school-3.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-interview.webp",
  },
    {
    src: "/images/gallery/harisharan_devgan_4.webp",
  },
  {
    src: "/images/gallery/harisharan-with-suresh-mansharamani-tajurba.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-receiving-award-at-tajurba-event.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-tajurba-business-meet.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-tajurba-event-2.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_14.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-01.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_5.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-in-tirupati.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_7.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-with-v. vijayendra-prasad.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-tajurba-event-1.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-10.webp",
  },
  // {
  //   src: "/images/harisharan_devgan_32.webp",
  // },

    {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-06.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_13.webp",
  },
  // {
  //   src: "/images/harisharan-devgan-cskhpkv-palampur-07.webp",
  // },
    {
    src: "/images/gallery/harisharan-devgan-performs-holy-pooja-at-srikalahasti_01.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-with-farmers.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-005.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-004.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_8.webp",
  },

  {
    src: "/images/gallery/harisharan_devgan_20.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-02.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_21.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-15.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_22.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-17.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_23.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_24.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_25.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_27.webp",
  },
    {
    src: "/images/gallery/harisharan_devgan_16.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_28.webp",
  },
 
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-08.webp",
  },
   {
    src: "/images/gallery/harisharan_devgan_31.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-in-tirupati-3.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-cskhpkv-palampur-18.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_6.webp",
  },
  // {
  //   src: "/images/harisharan-devgan-cskhpkv-palampur-19.webp",
  // },
  {
    src: "/images/gallery/harisharan_devgan_33.webp",
  },
  // {
  //   src: "/images/harisharan-devgan-in-tirupati-1.webp",
  // },
  {
    src: "/images/gallery/harisharan_devgan_39.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_34.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_41.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-neet-pg.webp",
  },
  {
    src: "/images/gallery/harisharan_devgan_42.webp",
  },
  {
    src: "/images/gallery/harisharaan-devgan-at-school-2.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-animal-trust-visit.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-sai-anugraha-animal-trust-meeting.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-farmer-agriculture-discussion.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-all-india-radio-akashvani-visit.webp",
  },
  {
    src: "/images/gallery/harisharan-devgan-wedding-blessing-ceremony.webp",
  },

];
  useEffect(() => {
    setImages(shuffleArray(originalImages));
  }, []);

  useEffect(() => {
    document.body.style.overflow = activeIndex !== null ? "hidden" : "auto";
  }, [activeIndex]);


  useEffect(() => {
    const handleKey = (e) => {
      if (activeIndex === null) return;

      if (e.key === "Escape") setActiveIndex(null);
      if (e.key === "ArrowRight")
        setActiveIndex((prev) => (prev + 1) % images.length);
      if (e.key === "ArrowLeft")
        setActiveIndex((prev) =>
          prev === 0 ? images.length - 1 : prev - 1
        );
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [activeIndex, images.length]);

  return (
    <>
      <Helmet>
        <title>Harisharan Devgan Photos | Official Photo Gallery</title>
        <meta
          name="description"
          content="Explore the photo gallery of Harisharan Devgan, featuring his agricultural work, public appearances, representation of students, social initiatives and filing of PIL filed in the Supreme Court."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Harisharan Devgan Photos | Official Photo Gallery" />
        <meta
          property="og:description"
          content="Explore the photo gallery of Harisharan Devgan, featuring his agricultural work, public appearances, representation of students, social initiatives and filing of PIL filed in the Supreme Court."
        />
        
        <meta property="og:site_name" content="Harisharan Devgan" />
        <meta property="og:updated_time" content="2026-02-01T11:53:28+05:30" />
        <meta
          property="og:image"
          content="https://harisharandevgan.com/images/harisharan-devgan-800.webp"
        />
        <meta
          property="og:image:secure_url"
          content="https://harisharandevgan.com/images/harisharan-devgan-800.webp"
        />
        <meta property="og:image:width" content="1024" />
        <meta property="og:image:height" content="576" />
        <meta property="og:image:alt" content="Connect" />
        <meta property="og:image:type" content="image/webp" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Harisharan Devgan Photos | Official Photo Gallery" />
        <meta
          name="twitter:description"
          content="Explore the photo gallery of Harisharan Devgan, featuring his agricultural work, public appearances, representation of students, social initiatives and filing of PIL filed in the Supreme Court."
        />
        <meta
          name="twitter:image"
          content="https://harisharandevgan.com/images/harisharan-devgan-800.webp"
        />
        <meta name="twitter:label1" content="Time to read" />
        <meta name="twitter:data1" content="Less than a minute" />

        {/* Favicons / Icons */}
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-touch-icon.png" />
        <link rel="manifest" href="/favicon/site.webmanifest" />
        <link rel="shortcut icon" href="/favicon/favicon.ico" />
      </Helmet>
      <SEO />
      {/* ===== Photos BANNER ===== */}
      <section className="relative min-h-[400px] flex items-center mt-[98px] overflow-hidden">
        <img
          src="/images/gallery/gallery-banner-new.webp"
          alt="Photos Page Banner"

          /* Performance */
          loading="eager"
          fetchpriority="high"
          decoding="async"

          /* CLS fix */
          width="1920"
          height="600"

          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70"></div>

        <div className="relative max-w-7xl mx-auto w-full px-6 grid grid-cols-1 md:grid-cols-2 items-center gap-8">
          {(() => {
            const { t } = useTranslation();

            return (
              <>
                <div>
                  <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-3">
                    {t("photos.title")}
                  </h1>
                  <p className="text-lg text-gray-300">
                    {t("photos.subtitle")}
                  </p>
                </div>

                <div className="md:text-right">
                  <h2 className="text-lg font-semibold text-white">
                    <Link
                      to="/"
                      className="text-gray-300 hover:text-orange-500 transition"
                    >
                      {t("common.home")}
                    </Link>
                    <span className="mx-2 text-gray-400">/</span>
                    <span className="text-orange-500">
                      {t("photos.title")}
                    </span>
                  </h2>
                </div>
              </>
            );
          })()}
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4 px-2 sm:px-4">

          {images.map((item, index) => (
            <div
              key={item.src}
              className="relative break-inside-avoid overflow-hidden rounded-lg"
            >

              <img
                src={item.src}
                loading="lazy"
                onClick={() => setActiveIndex(index)}
                className="w-full cursor-pointer rounded-lg hover:scale-[1.02] transition duration-300"
              />
            </div>
          ))}

        </div>
      </section>
      {/* ===== IMAGE MODAL ===== */}
      {activeIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center px-4"
          onClick={() => setActiveIndex(null)}
        >
          <img
            src={images[activeIndex].src}
            alt={images[activeIndex].alt}
            title={images[activeIndex].title}
            className="max-h-[90vh] max-w-[90vw] rounded-xl shadow-2xl"
          />

          <div className="absolute bottom-6 text-white text-sm tracking-widest">
            {activeIndex + 1} / {images.length}
          </div>

          <button
            className="absolute top-6 right-6 text-white text-3xl font-bold"
            onClick={() => setActiveIndex(null)}
          >
            ✕
          </button>
        </div>
      )}


      {/* Fade animation */}
      <style>{`
        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default Photos;
